// ======================================================================
// FILE:
// src/modules/service_crm/visits/components/VisitKpiBar.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit KPI Bar
// ======================================================================

import React from "react";

export default function VisitKpiBar({

  kpis = {},

}) {

  const cards = [

    {
      title:
        "Total Tickets",

      value:
        kpis.total_tickets || 0,

      icon:
        "🎫",

      color:
        "#0d6efd",
    },

    {
      title:
        "Total Visits",

      value:
        kpis.total_visits || 0,

      icon:
        "🛠️",

      color:
        "#198754",
    },

    {
      title:
        "Next Visit Required",

      value:
        kpis.next_visit_required || 0,

      icon:
        "📅",

      color:
        "#fd7e14",
    },

    {
      title:
        "Avg Visits / Ticket",

      value:
        kpis.avg_visits_per_ticket || 0,

      icon:
        "📊",

      color:
        "#6f42c1",
    },

  ];

  return (

    <div

      style={{

        display: "grid",

        gridTemplateColumns:
          "repeat(auto-fit,minmax(220px,1fr))",

        gap: 16,

        marginBottom: 20,

      }}

    >

      {cards.map((card) => (

        <div

          key={card.title}

          style={{

            background: "#fff",

            borderRadius: 14,

            padding: 18,

            boxShadow:
              "0 2px 8px rgba(0,0,0,0.08)",

            borderTop:
              `4px solid ${card.color}`,

          }}

        >

          <div

            style={{

              display: "flex",

              justifyContent:
                "space-between",

              alignItems:
                "center",

            }}

          >

            <div>

              <div

                style={{

                  fontSize: 12,

                  color: "#6c757d",

                }}

              >
                {card.title}
              </div>

              <div

                style={{

                  fontSize: 28,

                  fontWeight: 700,

                }}

              >
                {card.value}
              </div>

            </div>

            <div
              style={{
                fontSize: 28,
              }}
            >
              {card.icon}
            </div>

          </div>

        </div>

      ))}

    </div>

  );
}